/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const DeleteEntityInputJsonApiModel = {
  id: "",
  entity: {
    jsonApi: "hasOne",
    type: "entities",
  },
};
